import React from 'react'
import { Box } from '@mui/material'
import {
  Age,
  DoctorName,
  NameAge,
  ScheduledTime,
  StyledCard,
  StyledMenu,
  StyledMenuItem,
  WaitingPill,
  StyledLocalHospitalIcon,
  StyledInfoIcon,
  StyledDescriptionIcon,
  StyledStyleIcon,
  StyledBackButton,
  StyledArrowBackIcon,
  SurgeryName,
} from './PatientCard.styles'
import { usePatientCardLogic } from './PatientCard.logic'
import { TPatientCardProps } from './PatientCard.types'
import { getAgeFromDate, getProviderName, getTimeFromDate } from '../helpers'
import PatientManagementModal from '../PatientManagementModal/PatientManagementModal'
import { EPatientStatus } from '../RoomView.types'

const PatientCard: React.FC<TPatientCardProps> = (props) => {
  const logic = usePatientCardLogic(props)
  const { surgery } = props

  return (
    <>
      <StyledCard
        onClick={logic.handleClick}
        status={surgery.patientStatusHistory[0]?.status}
      >
        {surgery.patientStatusHistory[0]?.status ===
          EPatientStatus.CHECKED_IN && (
          <StyledBackButton
            onClick={(e) => {
              e.stopPropagation()
              logic.handleBackClick()
            }}
          >
            <StyledArrowBackIcon />
          </StyledBackButton>
        )}
        <NameAge>
          {`${
            surgery.patient.lastName
          }, ${surgery.patient.firstName[0].toUpperCase()}`}{' '}
          <Age>({getAgeFromDate(surgery.patient.dateOfBirth)}y)</Age>
        </NameAge>
        <DoctorName>
          {getProviderName(surgery.attendingProvider)}
          {logic.roomViewSettings.showProcedureName && (
            <SurgeryName> • {surgery.procedure.description}</SurgeryName>
          )}
        </DoctorName>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <ScheduledTime>
            {getTimeFromDate(surgery.procedure.dateTime)}
          </ScheduledTime>
          {surgery.patientStatusHistory?.[0]?.status !==
            EPatientStatus.ASSIGN_ROOM && (
            <WaitingPill>{logic.waitingTime || '0m'}</WaitingPill>
          )}
        </Box>
      </StyledCard>

      <StyledMenu
        anchorEl={logic.anchorEl}
        open={Boolean(logic.anchorEl)}
        onClose={logic.handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transitionDuration={200}
        elevation={0}
      >
        <StyledMenuItem
          onClick={(e) => logic.setRoomMenuAnchorEl(e.currentTarget)}
        >
          <StyledLocalHospitalIcon />
          Move to Room
        </StyledMenuItem>
        <StyledMenuItem
          onClick={() => {
            logic.setIsModalOpen(true)
            logic.handleClose()
          }}
        >
          <StyledInfoIcon />
          View Details
        </StyledMenuItem>

        <StyledMenuItem
          disabled={logic.disableDocumentSurgery}
          onClick={logic.handleNavigateToSurgery}
        >
          <StyledDescriptionIcon />
          Document Surgery
        </StyledMenuItem>

        <StyledMenuItem
          disabled
          onClick={() => {
            window.open(
              'http://localhost:3000/preference-card/683fe108b6e2699c725d89e5',
              '_blank',
              'noopener,noreferrer'
            )
            logic.handleClose()
          }}
        >
          <StyledStyleIcon />
          View Preference Card
        </StyledMenuItem>
      </StyledMenu>

      <StyledMenu
        anchorEl={logic.roomMenuAnchorEl}
        open={!!logic.roomMenuAnchorEl}
        onClose={logic.handleRoomMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transitionDuration={200}
        elevation={0}
      >
        {logic.rooms.map((room) => {
          const isRoomOccupied = logic.scheduledSurgeries.some(
            (surgery) =>
              surgery?.patientStatusHistory[0]?.info?.room?.id === room.id &&
              surgery?.patientStatusHistory[0]?.status ===
                EPatientStatus.ASSIGN_ROOM
          )
          return (
            <StyledMenuItem
              key={room.id}
              onClick={() => logic.handleMoveToRoom(room)}
              disabled={isRoomOccupied}
            >
              {room.name}
            </StyledMenuItem>
          )
        })}
      </StyledMenu>

      <PatientManagementModal
        open={logic.isModalOpen}
        onClose={() => logic.setIsModalOpen(false)}
        patient={surgery.patient}
      />
    </>
  )
}

export default PatientCard
